<svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 537.79 203.21">
  <defs>
    <style>
      .cls-1 {
        stroke: #000;
        stroke-linejoin: round;
      }

      .cls-1, .cls-2, .cls-3, .cls-4 {
        fill: none;
      }

      .cls-1, .cls-2, .cls-4 {
        stroke-width: 8px;
      }

      .cls-2 {
        stroke-dasharray: 12.09 12.09;
      }

      .cls-2, .cls-3, .cls-4 {
        stroke-miterlimit: 10;
      }

      .cls-2, .cls-4 {
        stroke: #96d6a7;
      }

      .cls-5 {
        fill: #00a352;
      }

      .cls-3 {
        stroke: #00a352;
        stroke-linecap: round;
        stroke-width: 12px;
      }
    </style>
  </defs>
  <g id="Ebene_3" data-name="Ebene 3">
    <g>
      <path class="cls-1" d="M533.72,178.41c-.04.61-.42,1.14-1,1.35-28.2,9.99-86.82,17.82-171.33,19.34-85.46,1.53-147.28-12.87-205.63-8.25-51.9,4.11-132.82-8.89-144.69-10.34-1.54-.19-2.79-1.34-3.08-2.87-.39-2.1-.8-5.43-1.1-9.83-.14-2.13,1.69-3.86,3.8-3.6,15.13,1.83,94.37,14.37,145.06,10.29,58.34-4.7,120.18,10.16,205.63,8.24,101.32-2.27,137.35-10.97,169.94-18.59.72-.17,1.44.31,1.55,1.04,1.03,6.84.96,11.31.85,13.22Z"/>
      <g>
        <path class="cls-4" d="M121.4,64.64s2.21-.06,5.99-.33"/>
        <path class="cls-2" d="M139.42,63.16c18.45-2.2,47.13-7.59,66.74-20.67,27.51-18.34,28.8-21.01,72.01,3.72,48.64,27.85,82.26,42.24,109.67,48.01,18.53,3.89,45.86,6.2,61.44,7.27"/>
        <path class="cls-4" d="M455.31,101.89c3.76.23,5.99.34,5.99.34"/>
      </g>
      <path class="cls-1" d="M527.12,165.03c-28.41,6.84-80.54,16.18-165.73,17.71-85.46,1.53-147.28-12.87-205.63-8.24-57.6,4.56-143.38-10.08-144.96-10.29-3.81-17.2-8.62-44.74-6.1-65.67C8.66,65.57,28.06,13.3,41.45,28.36c11.86,13.34,49.82,41.67,89.97,35.4,40.15-6.28,57.41-20.92,74.48-37.89,24.33-24.21,25.37-31.58,66.97-5.24,41.6,26.34,96.09,52.73,115.55,61.59s49.47,20.22,77.76,20.35c28.29.13,51.06-5.63,57.45,28.8,2.34,12.63,3.2,24.6,3.49,33.66Z"/>
      <path class="cls-3" d="M349.83,42.89c-.9-14.52-5.93-25.81-15.29-31.58-24.36-15.02-68.88,12.97-99.42,62.51-18.2,29.52-24.34,58.47-26.6,83.06"/>
      <path class="cls-5" d="M352.16,51.89l12.29-22.35c.9-1.63-.45-3.59-2.29-3.33l-30.11,4.1c-1.84.25-2.61,2.49-1.32,3.83l17.81,18.26c1.06,1.09,2.87.84,3.61-.49Z"/>
    </g>
  </g>
</svg>
